import { useSingleEtfMarketReactionLines } from './hooks/useSingleEtfMarketReactionLines';
import { MarketCatalystReactionChartView } from './MarketCatalystReactionChartView';
import { MarketCatalystReactionProps } from './market-catalyst-reaction.types';

export const SingleEtfMarketCatalystReaction = ({
  tags,
  tickers,
  createdAt,
  themeId,
  leftHeaderNode,
  chartHeaderVariant,
  trackingSource,
}: MarketCatalystReactionProps) => {
  const { lines, fromDateEST, toDateEST, isDailyFallback, isLoading } =
    useSingleEtfMarketReactionLines({ tags, tickers, createdAt, themeId });

  return (
    <MarketCatalystReactionChartView
      isLoading={isLoading}
      fromDateEST={fromDateEST}
      toDateEST={toDateEST}
      lines={lines}
      leftHeaderNode={leftHeaderNode}
      isDailyFallback={isDailyFallback}
      trackingSource={trackingSource}
      chartHeaderVariant={chartHeaderVariant}
    />
  );
};
